import React, { useEffect, useMemo, useState } from "react";
import {
  HeaderListComponent,
  LoadingComponent,
  PageListComponent,
  ListComponent,
  DatePickerComponent,
  FilterDropdown,
  StatusComponent
} from "../../../common/component/Index";
import Wrapper from "../../../common/component/Wrapper";
import Button from "../../../common/component/Button";
import {
  columnsTable,
  getDataSource,
  getTitleTable,
  capitalizeFirstLetter,
  formatMoney,
  genaratePaginateFilterSort,
  getPermissionActions
} from "../../../../../helpers/functions";
import DEFINE, { DATE_TIME_FORMAT, CHECKOUT_PMS, COLLABORATOR_REPORT } from "../../../../../constants/Define";
import { compact, omit, pickBy } from "lodash";
import * as ANT from "antd";
import "./CollaboratorReport.less";
import moment from 'moment';
import { Select, DatePicker, Checkbox, Tag, Modal, Icon, PageHeader } from 'antd';
import { Link } from "react-router-dom";

const ReportListCols = [ "id", "name", "email", "phoneNumber", "orderCode", "status", "createdDate", "departureDate", "orderAmount", "orderCumulativeCode", "orderCumulativeAmount", "checkOutPms", "isAccumulated", "orderId" ];

const CollaboratorReport = (props) => {
  const { getCollaboratorReport, collaboratorState, loadingCollaborator, crossCheckPMS, isFetchingCrossCheck, isCrossCheckStatus, setDefaultStatusCrossCheck, t, getExportCollaboratorReport, isFetchingExportCollaborator } = props;
  const permisionActions = useMemo(() => getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.COLLABORATOR_REPORT), []);
  const titleItemTable = useMemo(() => getTitleTable(ReportListCols, [], ["id", "orderId"]),[]);
  const componentTable = useMemo(
    () => ({
      name: {
        key: "name",
        width: 200,
        filterDropdown: ({setSelectedKeys,selectedKeys,confirm,clearFilters}) => (
          <FilterDropdown setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys} confirm={confirm} clearFilters={clearFilters}/>
        ),
        filterIcon: (filtered) => (<ANT.Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />),
      },
      email: {
        key: "email",
        width: 200,
        filterDropdown: ({setSelectedKeys,selectedKeys,confirm,clearFilters}) => (
          <FilterDropdown setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys} confirm={confirm} clearFilters={clearFilters}/>
        ),
        filterIcon: (filtered) => (<ANT.Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />),
      },
      phoneNumber: {
        key: "phoneNumber",
        width: 200,
        filterDropdown: ({setSelectedKeys,selectedKeys,confirm,clearFilters}) => (
          <FilterDropdown setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys} confirm={confirm} clearFilters={clearFilters}/>
        ),
        filterIcon: (filtered) => (<ANT.Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />),
      },
      orderCode: {
        key: "orderCode",
        width: 200,
        filterDropdown: ({setSelectedKeys,selectedKeys,confirm,clearFilters}) => (
          <FilterDropdown setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys} confirm={confirm} clearFilters={clearFilters}/>
        ),
        filterIcon: (filtered) => (<ANT.Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />),
        render: ((orderCode, data) => {
            return <Link to={`/orders/${data?.orderId}`} className={`mr-2 colorPrimary`}>{orderCode}
            </Link>
        })
      },
      status: {
        key: "status",
        width: 200,
        filters: COLLABORATOR_REPORT.STATUS.map(el => ({...el, text: t(`item.collaboratorReport.orderStatus.${el.text}`)})),
        filterMultiple: false,
        render: (status) => t(`item.collaboratorReport.orderStatus.${status}`)
        
      },
      createdDate: {
        key: "createdDate",
        width: 200,
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.createdDate - b.createdDate,
        // filterDropdown: ({setSelectedKeys,selectedKeys,confirm,clearFilters}) => (
        //   <FilterDropdown setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys} confirm={confirm} clearFilters={clearFilters}/>
        // ),
        // filterIcon: (filtered) => (<ANT.Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />),
        render: (createdDate) => moment(moment.utc(createdDate).toDate().toJSON()).format(DATE_TIME_FORMAT.DATE_TIME)
      },
      departureDate: {
        key: "departureDate",
        width: 200,
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.departureDate - b.departureDate,
        // filterDropdown: ({setSelectedKeys,selectedKeys,confirm,clearFilters}) => (
        //   <FilterDropdown setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys} confirm={confirm} clearFilters={clearFilters}/>
        // ),
        // filterIcon: (filtered) => (<ANT.Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />),
        render: (departureDate) => moment(moment.utc(departureDate).toDate().toJSON()).format(DATE_TIME_FORMAT.DATE_TIME)
      },
      orderAmount: {
        key: "orderAmount",
        width: 200,
        render: (orderAmount) => formatMoney(orderAmount)
      },
      orderCumulativeCode: {
        key: "orderCumulativeCode",
        width: 200,
        render: (orderCumulativeCode) => orderCumulativeCode
      },
      orderCumulativeAmount: {
        key: "orderCumulativeAmount",
        width: 200,
        render: (orderCumulativeAmount) => formatMoney(orderCumulativeAmount)
      },
      checkOutPms: {
        key: "checkOutPms",
        width: 200,
        filters: [
          { value: CHECKOUT_PMS.NO, text: "NO" },
          { value: CHECKOUT_PMS.YES, text: "YES" },
          { value: CHECKOUT_PMS.ALTER, text: "ALTER" },
        ],
        filterMultiple: false,
        render: (checkOutPms) => 
          <StatusComponent
            color={checkOutPms === 1 ? 'green-inverse' : checkOutPms === 2 ? "red-inverse" : 'gold-inverse'}
            label={checkOutPms === 1 ? 'YES' : checkOutPms === 2 ? "Alter" : 'NO'}
          />
      },
      isAccumulated: {
        key: "isAccumulated",
        width: 200,
        filters: [
          { value: 0, text: "NO" },
          { value: 1, text: "YES" },
        ],
        filterMultiple: false,
        render: (isAccumulated) =>
          <StatusComponent
            color={isAccumulated ? 'green-inverse' : 'gold-inverse'}
            label={isAccumulated ? "YES"  : "NO"}
          />
      },
    }),
    []
  );

  const [filter, setFilter] = useState({});
  const [checkedItem, setCheckedItem] = useState([]);

  const filterCollaboratorReport = (filters) => {
    if (!filters) {
      filters = omit(collaboratorState, ["items", "totalCount", "totalPage"]);
    }
    setFilter(filters);
    getCollaboratorReport(filters);
  };

  const onExportExcel = () => {
    const newFilter = pickBy(filter, Boolean);
    getExportCollaboratorReport({
      ...newFilter,
      ...newFilter?.startDate ? {startDate: moment.utc(newFilter?.startDate).toISOString()} : {},
      ...newFilter?.endDate ? {endDate: moment.utc(newFilter?.endDate).toISOString()} : {}
    });
  };

  useEffect(() => {
    filterCollaboratorReport();
  }, []);

  useEffect(() => {
    if(isCrossCheckStatus) {
      setCheckedItem([]);
      filterCollaboratorReport(filter);
    }
  },[isCrossCheckStatus])

  const onTableChange = (pagination, filters, sorter) => {
    let newFilter = genaratePaginateFilterSort(pagination, filters, sorter);
    newFilter.startDate = !filter.startDate ? undefined: moment.utc(filter.startDate);
    newFilter.endDate = !filter.endDate ? undefined: moment.utc(filter.endDate);
    if(filter.pageSize !== pagination.pageSize){
      newFilter.pageIndex = 1;
    }
    filterCollaboratorReport(newFilter)
  };

  const onSelectDateRange = (data) => {
    const newFilter = { ...filter };
    newFilter.pageIndex = 1;
    newFilter.startDate = data.fullValue[0];
    newFilter.endDate = data.fullValue[1];
    filterCollaboratorReport(newFilter);
  };

  const rowSelection = {
    selectedRowKeys: checkedItem,
    onChange: (selectedRowKeys) => setCheckedItem(selectedRowKeys),
    getCheckboxProps: (record) => ({
        disabled: record.checkOutPms === 1 && record.isAccumulated,
        name: record.name,
      })
  }

  const onCrossCheckpms = () => {
    crossCheckPMS(checkedItem);
    setDefaultStatusCrossCheck();

  };
  const onTopupPoint = () => {};

  const CustomButton = ({ onPress = () => {}, title = "", disabled = false, loading = false }) => {
    return (
      <Button
        type="primary"
        onClick={onPress}
        icon="download"
        loading={loading}
        disabled={!collaboratorState?.items || disabled}
        className="mr-2 height-btn"
      >
        {title}
      </Button>
    );
  };

  return (
    <Wrapper className="col-md-12 p-0 mt-3 report-list">
      <PageListComponent className="cash-flow-detail-page">
        <HeaderListComponent
          path={props.match.path}
          groupPath={"cashFlow"}
          titleHeader={capitalizeFirstLetter(
            `${t("item.collaboratorReport.title")}`.toLowerCase()
          )}
        />
        <Wrapper className={`d-flex row`}>
          <Wrapper className="col-6">
            <CustomButton
              disabled={!permisionActions?.allowCheck || !checkedItem.length || isFetchingCrossCheck}
              onPress={onCrossCheckpms}
              title={t(`item.collaboratorReport.crosscheckpms`)}
              loading={isFetchingCrossCheck}
            />
            <CustomButton
              onPress={onTopupPoint}
              title={t(`item.collaboratorReport.topupPoint`)}
              disabled
            />
          </Wrapper>
          <Wrapper className="col-6">
            <Wrapper className="row">
              <DatePickerComponent
                className={`form-control applyDates col-6 align-items-end`}
                hmsComponent={`RangePicker`}
                format={DATE_TIME_FORMAT.SHORT_DATE}
                style={{ padding: 0, border: 0 }}
                onChange={onSelectDateRange}
                name={`applyDates`}
                placeholder={[
                  t("placeHolderForm.startDate"),
                  t("placeHolderForm.endDate"),
                ]}
                value={[filter.startDate, filter.endDate]}
              />
              <Wrapper className="col-6 align-items-end">
                <CustomButton
                  onPress={onExportExcel}
                  title={t(`item.collaboratorReport.export`)}
                  loading={isFetchingExportCollaborator}
                />
              </Wrapper>
            </Wrapper>
          </Wrapper>
        </Wrapper>
        <Wrapper className={`mt-3`}>
          <ListComponent
            className="cash-flow-report"
            tableKey="sale-report-list"
            classParent="m-0 p-0"
            marginTop={"0"}
            marginBottom={"0"}
            // scroll={{ x: 4200 }}
            scroll={{ x: 'max-content' }}
            tableLayout='auto'
            loading={{ spinning: loadingCollaborator, size: "large" }}
            rowKey={(record, k) => record.id}
            dataSource={getDataSource(
              collaboratorState?.items || [],
              ReportListCols
            )}
            columns={columnsTable({
              titleTable: titleItemTable,
              component: componentTable,
              itemName: "collaboratorReport",
            })}
            pagination={{
              total: collaboratorState.totalCount,
              totalPage: collaboratorState.totalPage,
              current: filter.pageIndex,
              pageSize: filter.pageSize,
            }}
            onChange={onTableChange}
            rowSelection={{type: 'checkbox',...rowSelection}}
            componentTableList={{}}
          />
        </Wrapper>
      </PageListComponent>
    </Wrapper>
  );
};

export default CollaboratorReport;
